import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ compact = false }) {
  const [target, setTarget] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    axios.get(`${API}/settings`).then(({ data }) => {
      if (data.launch_date) setTarget(new Date(data.launch_date).getTime());
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!target) return null;

  const diff = Math.max(0, target - now);
  const units = [
    { label: "Days", value: pad(Math.floor(diff / 86400000)) },
    { label: "Hours", value: pad(Math.floor(diff / 3600000) % 24) },
    { label: "Minutes", value: pad(Math.floor(diff / 60000) % 60) },
    { label: "Seconds", value: pad(Math.floor(diff / 1000) % 60) },
  ];

  return (
    <div data-testid="launch-countdown" className={compact ? "" : "mx-auto max-w-2xl"}>
      <p className="mb-6 text-center text-xs uppercase tracking-[0.35em] text-zinc-500">
        {diff === 0 ? "CHWA-01 is live" : `CHWA-01 launches ${new Date(target).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}`}
      </p>
      <div className="grid grid-cols-4 border border-zinc-800">
        {units.map((u, i) => (
          <div key={u.label} data-testid={`countdown-${u.label.toLowerCase()}`} className={`px-2 py-6 text-center ${i < 3 ? "border-r border-zinc-800" : ""}`}>
            <p className="font-display text-4xl font-bold leading-none text-zinc-50 md:text-6xl">{u.value}</p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">{u.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
